module.exports = __webpack_public_path__ + "static/img/22.7bca915.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/22.png
// module id = E/sc
// module chunks = 0